import {
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";

import { auth } from "./config";


// ============================================
// Google Provider
// ============================================

const googleProvider = new GoogleAuthProvider();


// ============================================
// Login with Google
// ============================================

export const loginWithGoogle = async () => {
  try {
    const result = await signInWithPopup(
      auth,
      googleProvider
    );

    return {
      success: true,
      user: result.user,
      error: null,
    };

  } catch (error) {
    console.error("Google login error:", error);

    return {
      success: false,
      user: null,
      error,
    };
  }
};


// ============================================
// Logout
// ============================================

export const logout = async () => {
  try {
    await signOut(auth);

    return {
      success: true,
      error: null,
    };

  } catch (error) {
    console.error("Logout error:", error);

    return {
      success: false,
      error,
    };
  }
};


// ============================================
// Get current user
// ============================================

export const getCurrentUser = () => {
  return auth.currentUser;
};


// ============================================
// Listen for authentication changes
// ============================================

export const onAuthChange = (callback) => {
  return onAuthStateChanged(auth, callback);
};